module.exports = __webpack_public_path__ + "static/media/collage.90395d5c.jpg";